module.exports = __webpack_public_path__ + "static/img/son2_active.a0f742cf.png";